import React, { useRef, useState } from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import {
  validaSoloNumero
} from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes';
import CatalogoModelo from '../../catalogos/catalogoModelo';
import moment from 'moment';
import CatalogoAlmacen from '../../catalogos/catalogoAlmacen';
import CatalogoProductosExistencias from '../../catalogos/catalogoProductosExistencias';

export const ImprimirProductos = (props) => {

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  const fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));


  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtInputAlmacen = useRef();
  const txtInputProducto = useRef();
  const txtTodosAlmacen = useRef();
  const txtPorAlmacen = useRef();
  const txtTodosDispo = useRef();
  const txtEnStock = useRef();
  const txtAgotados = useRef();
  const txtTodosProductos = useRef();
  const txtPorProductos = useRef();
  const txtIdProducto = useRef();
  const txtRifrespon = useRef();
  const txtNomrespon = useRef();
  const txtNombreAlmacen = useRef();
  const txtNombreProducto = useRef();
  const txtTipoproducto = useRef();
  const txtMarca = useRef();
  const txtFabricante = useRef();
  const txtCheckPrecio = useRef();
  const txtHistorico = useRef();
  const txtFechaal = useRef();

  const [inputalmacen, setInputalmacen] = useState(0);
  const [inputproducto, setInputproducto] = useState(0);
  const [validaprecio, setValidaprecio] = useState(0);
  const [tipoproducto, setTipoproducto] = useState([]);
  const [mostrar, setMostrar] = useState(null);
  const [mostrar1, setMostrar1] = useState(null);
  const [almacenc, setAlmacenc] = useState('');
  const [disponiblec, setDisponiblec] = useState('');
  const [cantis, setCantis] = useState('0');
  const [productoc, setProductoc] = useState('');
  const [idproductos, setIdproductos] = useState('');
  const [idalmacenc, setIdalmacenc] = useState('');
  const [activate, setActivate] = useState(false);
  const [habilitado, setHabilitado] = useState(true);
  const [habimarcatipopro, setHabimarcatipopro] = useState(false);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [marca, setMarca] = useState([]);
  const [fabricante, setFabricante] = useState([]);
  const [idmarca, setIdmarca] = useState('');
  const [idfabricante, setIdfabricante] = useState('');
  const [idtproduct, setIdtproduct] = useState('');
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    salir: false
  });



  const blanquear = () => {
    setActivate(false);
    setInputalmacen(0);
    setAlmacenc('');
    setDisponiblec('');
    setCantis('0');
    setProductoc('');
    setInputproducto(0);
    setValidaprecio(0);
    setIdalmacenc('');
    setIdproductos('');
    setIdmarca('');
    setIdfabricante('');
    setIdtproduct('');
    setHabimarcatipopro(false);
    setMarca([]);
    setFabricante([]);
  }

  const cancelar = () => {
    blanquear();
    props.onHideCancela();

  };

  const onChangeValidar = (e) => {
    e.preventDefault();

    let sigue = true;
    if (props.op === 1) {

      if (txtPorAlmacen.current.checked === true && txtPorProductos.current.checked === false) {
        if (txtInputAlmacen.current.value === '') {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Almacen a Consultar !', icono: 'informacion' });
          txtInputAlmacen.current.focus()
          sigue = false
        } else {
          imprimirGeneral();
        }

      } else if (txtPorAlmacen.current.checked === false && txtPorProductos.current.checked === true) {
        if (txtInputProducto.current.value === '') {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Producto a Consultar !', icono: 'informacion' });
          txtInputProducto.current.focus()
          sigue = false
        } else {
          imprimirGeneral();
        }
      } else if (txtPorAlmacen.current.checked === true && txtPorProductos.current.checked === true) {
        if (txtInputProducto.current.value === '') {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Producto a Consultar !', icono: 'informacion' });
          txtInputProducto.current.focus()
          sigue = false
        } else if (txtInputAlmacen.current.value === '') {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Almacen a Consultar !', icono: 'informacion' });
          txtInputAlmacen.current.focus()
          sigue = false
        } else {
          imprimirGeneral();
        }
      } else {
        imprimirGeneral();
      }

    }

  }

  const onChekval = (e) => {

    if (e.target.id === 'tipoalmacen') {

      if (txtTodosAlmacen.current.checked === true) {

        setInputalmacen(0);
        setAlmacenc('');
        setIdalmacenc('');
        txtNomrespon.current.value = '';
        txtRifrespon.current.value = '';
        txtNombreAlmacen.current.value = '';

      } else if (txtPorAlmacen.current.checked === true) {

        setInputalmacen(1);
        setAlmacenc(' and a.idalmacen =');

      }

    } else if (e.target.id === 'tipodisponible') {

      if (e.target.value === '1') {
        setDisponiblec('');
      } else if (e.target.value === '2') {
        setDisponiblec(' and e.cantidad > 0.00');
      } else if (e.target.value === '3') {
        setDisponiblec(' and e.cantidad = 0.00');
      }

    } else if (e.target.id === 'tipoproducto') {

      if (txtTodosProductos.current.checked === true) {
        setInputproducto(0);
        setProductoc('');
        setIdproductos('');
        setHabimarcatipopro(false);
        txtNombreProducto.current.value = '';
      } else if (txtPorProductos.current.checked === true) {
        setInputproducto(1);
        setHabimarcatipopro(true);
        setProductoc(' and p.idproducto =');
      }

    }

    if (e.target.name === 'valprecio') {
      if (txtCheckPrecio.current.checked === true) {
        setValidaprecio(1);
        setCantis('0');
        txtHistorico.current.checked = false;
      } else {
        setValidaprecio(0);
        setCantis('0');
        txtHistorico.current.checked = false;
      }
    }

    if (e.target.name === 'historico') {
      if (txtHistorico.current.checked === true) {
        setCantis('1');
        setValidaprecio(0);
        txtCheckPrecio.current.checked = false;
      } else {
        setCantis('0');
        setValidaprecio(0);
        txtCheckPrecio.current.checked = false;
      }
    }

  }

  const onChange = (e) => {

    if (e.target.name === 'tproducto') {
      if (e.target.value === '0') {
        setIdtproduct('');
      } else {
        let valor = ' and p.idtipoproducto = ' + e.target.value;
        setIdtproduct(valor);
      }
    } else if (e.target.name === 'fabricante') {
      if (e.target.value === '0') {
        setIdfabricante('');
      } else {
        let valor = ' and p.idfabricante = ' + e.target.value;
        setIdfabricante(valor);
      }
    } else if (e.target.name === 'marca') {
      if (e.target.value === '0') {
        setIdmarca('');
      } else {
        let valor = ' and p.marca = ' + e.target.value;
        setIdmarca(valor);
      }
    }

  }

  const imprimirGeneral = () => {

    var reporte = "";
    let valc = cantis === '1' ? '' : disponiblec;
    let condi = almacenc + idalmacenc + valc + productoc + idproductos + idtproduct + idmarca + idfabricante;

    if (validaprecio === 1 && cantis === '0') {
      reporte = "ListProductoExistenciaDos";
    } else if (validaprecio === 0 && cantis === '1') {
      reporte = "ListaProductoExistencia";
    } else {
      reporte = "ListaProductoExistenciareal";
    }

    let tipo = 0;
    let alafecha = txtFechaal.current.value;


    if (idtproduct !== '' && idmarca !== '' && idfabricante !== '') {
      tipo = 4;
    } else if (idtproduct !== '' && idmarca !== '' && idfabricante === '') {
      tipo = 3;
    } else if (idtproduct !== '' && idmarca === '' && idfabricante !== '') {
      tipo = 2;
    } else if (idtproduct === '' && idmarca !== '' && idfabricante !== '') {
      tipo = 1;
    } else {
      tipo = 0;
    }
    window.open(op.reportes + "/productos?afiliado=" + afiliado + "&reporte=" + reporte + "&condicion=" + condi + "&alafecha=" + moment(alafecha).format('DD-MM-YYYY') + "&tipo=" + tipo, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
  }

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });

  };

  const cerrarModal = () => {
    if (props.llamado === 2) {
      props.onHideRenderizar();
      props.onHideCancela();
    }
    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
  }

  const handleAceptaAlmacen = (values) => {
    setMostrar(false);
    txtInputAlmacen.current.value = values.idalmacen;
    txtNombreAlmacen.current.value = values.descripcion;
    selectResponsable(values.responsable.substring(1, 9));
    setIdalmacenc(values.idalmacen);
  };

  const handleAceptaProducto = (values) => {
    setMostrar1(false);
    txtInputProducto.current.value = values.codigo;
    txtNombreProducto.current.value = values.nombrecorto;
    setIdproductos(values.idproducto);
  };

  const catalogoAlmacenc = (e) => {
    e.preventDefault();
    setMostrar(true);
  };

  const catalogoProductoc = (e) => {
    e.preventDefault();
    setMostrar1(true);
  };

  const selectAlmacen = (id) => {

    let campos = '*';
    let nomtab = 'almacen';
    let nomid = 'idalmacen';
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    //let endpoint = `${op.conexion}/api/inventario/almacenpordescripcion?descripcion=${"'"+descrip.toUpperCase()+"'"}`;
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {
        if (response.data.idalmacen > 0) {
          txtInputAlmacen.current.value = response.data.idalmacen;
          txtNombreAlmacen.current.value = response.data.descripcion;
          setIdalmacenc(response.data.idalmacen);
          selectResponsable(response.data.responsable.substring(1, 9));
        } else {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Código y/o Almacen no Registrado !', icono: 'error' });
        }
      }
    }).catch(function (error) {
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })
  };

  const selectResponsable = (id) => {
    let campos = '*';
    let nomtab = 'persona';
    let nomid = 'cedula';
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {
        if (response.data.cedula > 0) {
          txtNomrespon.current.value = response.data.nombres.trim() + ' ' + response.data.apellidos.trim();
          txtRifrespon.current.value = response.data.cedula;
        }
      }
    }).catch(function (error) {
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })
  };

  const seleccionarProducto = (id) => {

    let endpoint = `${op.conexion}/api/inventario/productosenexistenciaid?id=${id}`;

    setActivate(true);

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status === 200) {
        if (response.data.idproducto > 0) {
          txtInputProducto.current.value = response.data.codigo;
          txtNombreProducto.current.value = response.data.nombrecorto;
          setIdproductos(response.data.idproducto);
        } else {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Código y/o Producto no Registrado !', icono: 'error' });
        }
      }


    }).catch(function (error) {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    }).finally(() => {
      setActivate(false);
    })

  }

  const handleProducto = (e) => {
    e.preventDefault();
    if (e.which === 13 || typeof (e.which) === 'undefined') {
      if (e.target.value !== '') {
        seleccionarProducto("'" + e.target.value.toUpperCase() + "'");
      }
    }
  };

  const handleAlmacen = (e) => {
    e.preventDefault();
    if (e.which === 13 || typeof (e.which) === 'undefined') {
      if (e.target.value !== '') {
        selectAlmacen(e.target.value);
      }
    }
  };

  const seleccionarTipoProductos = () => {

    let campos = 'idtipoproducto, trim(descripcion) as descripcion';
    let nomtab = 'tipoproducto';
    let orden = 'idtipoproducto';

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status === 200) {
        if (response.data.length > 0) {

          let datos = [];

          for (let i = 0; i < response.data.length; i++) {

            if (response.data[i].idtipoproducto !== '0') {
              datos.push({
                idtipoproducto: response.data[i].idtipoproducto,
                descripcion: response.data[i].descripcion
              });
            }

          }
          setTipoproducto(datos);
        }
      }


    }).catch(function (error) {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    }).finally(() => {
      setActivate(false);
    })

  }

  const seleccionarMarca = () => {

    let campos = 'idmarca, trim(descripcion) as descripcion';
    let nomtab = 'marca';
    let orden = 'idmarca';

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status === 200) {
        if (response.data.length > 0) {

          let datos = [];

          for (let i = 0; i < response.data.length; i++) {

            if (response.data[i].idmarca !== '0') {
              datos.push({
                idmarca: response.data[i].idmarca,
                descripcion: response.data[i].descripcion
              });
            }

          }
          setMarca(datos);
        }
      }


    }).catch(function (error) {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    }).finally(() => {
      setActivate(false);
    })

  }

  const seleccionarFabricante = () => {

    let campos = 'idfabricante, trim(descripcion) as descripcion';
    let nomtab = 'fabricante';
    let orden = 'idfabricante';

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status === 200) {
        if (response.data.length > 0) {

          let datos = [];

          for (let i = 0; i < response.data.length; i++) {

            if (response.data[i].idfabricante !== '0') {
              datos.push({
                idfabricante: response.data[i].idfabricante,
                descripcion: response.data[i].descripcion
              });
            }

          }
          setFabricante(datos);
        }
      }


    }).catch(function (error) {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    }).finally(() => {
      setActivate(false);
    })

  }

  const imprimir2 = async () => {

    let valc = cantis === '1' ? '' : disponiblec;
    let condi = almacenc + idalmacenc + valc + productoc + idproductos + idtproduct + idmarca + idfabricante;
    let tipo = 0;
    window.open(
      op.reportes +
      "/productos?afiliado=" +
      afiliado +
      "&reporte=ListProductoExistenciaCatalogo" +

      "&condicion=" +
      condi +
      "&tipo=" +
      tipo,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {

        if (props.op === 1) {
          txtTodosAlmacen.current.checked = true;
          txtTodosDispo.current.checked = true;
          txtTodosProductos.current.checked = true;
          setAlmacenc('');
          setDisponiblec('');
          setProductoc('');
          seleccionarTipoProductos();
          seleccionarFabricante();
          seleccionarMarca();
          txtPorAlmacen.current.checked = false;
          txtEnStock.current.checked = false;
          txtAgotados.current.checked = false;
          txtPorProductos.current.checked = false;
          setHabilitado(false);
          txtFechaal.current.value = moment(fechasistema).format('YYYY-MM-DD');
        } else {
          txtTodosAlmacen.current.checked = false;
          txtTodosDispo.current.checked = false;
          txtTodosProductos.current.checked = false;

          txtPorAlmacen.current.checked = false;
          txtEnStock.current.checked = false;
          txtAgotados.current.checked = false;
          txtPorProductos.current.checked = false;
          setHabilitado(true);
        }

      }}
    >
      <Modal.Header className='azulGradiant2 header-modal'>
        <div className='fw-bold' style={{ color: "#fff" }}><h3>Imprimir Lista de Productos</h3></div>

        <a href='#' ref={btnSalir} disabled={botones.salir} onClick={cancelar} className='text-light' ><i className="fas fa-times fa-1x shadow" > {/* Salir */}</i></a>

      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === 'Exito.' ?
              cerrarModal() :
              setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }
          } />
        <MensajeSiNo mensaje={mensajesino}
          onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className='col-md-12 row mx-auto px-0'>

          <div className="row col-md-12 rounded mx-auto">

            <div className='col-7 ml-auto row m-0'>
              <div className="form-check col-6">
                <input className="form-check-input" ref={txtHistorico} name='historico' onChange={onChekval} type="checkbox" value="" id="flexCheckDefault1" />
                <label className="form-check-label" for="flexCheckDefault1">
                  Historico Existencia
                </label>
              </div>
              <div className="form-check col-5 ml-auto">
                <input className="form-check-input" ref={txtCheckPrecio} name='valprecio' onChange={onChekval} type="checkbox" value="" id="flexCheckDefault" />
                <label className="form-check-label" for="flexCheckDefault">
                  Solo Precio de Venta
                </label>
              </div>
            </div>

            <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1'>
              <legend className="float-none m-0 w-auto fs-4 fw-bold">Almacén:</legend>

              <div className='col-3 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="tipoalmacen" value="1" ref={txtTodosAlmacen} onChange={onChekval} id="tipoalmacen" type="radio" />
                  <label className="form-check-label" for="exampleRadi1">
                    Todos
                  </label>
                </div>
              </div>

              <div className='col-3 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="tipoalmacen" value="2" ref={txtPorAlmacen} onChange={onChekval} id="tipoalmacen" type="radio" />
                  <label className="form-check-label" for="exampleRadi2">
                    Por Almacen
                  </label>
                </div>
              </div>

              {inputalmacen === 1 ? <div className='col-4 mr-auto'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">Código Almacén:</label>
                  <input type="text" ref={txtInputAlmacen} disabled={inputalmacen === 1 ? false : true} onKeyUp={handleAlmacen} onBlur={handleAlmacen} className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  <button disabled={inputalmacen === 1 ? false : true} type="button" onClick={catalogoAlmacenc} className="btn btn-success"><i className="fas fa-search"></i></button>
                </div>
              </div> : ''}

              {inputalmacen === 1 ? <div className='col-12 row m-0 py-3'>

                <div className='col-12'>
                  <div className="input-group input-group-sm">
                    <label className="input-group-text" id="inputGroup-sizing-sm">Nombre del Almacén:</label>
                    <input type="text" ref={txtNombreAlmacen} disabled={true} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  </div>
                </div>

                <div className='col-12 row m-0'>
                  <div className="input-group input-group-sm col-9 px-0">
                    <label className="input-group-text" id="inputGroup-sizing-sm">Responsable:</label>
                    <input type="text" ref={txtNomrespon} disabled={true} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  </div>

                  <div className="input-group input-group-sm col-3 px-0">
                    <label className="input-group-text" id="inputGroup-sizing-sm">Cédula:</label>
                    <input type="text" ref={txtRifrespon} disabled={true} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  </div>
                </div>
              </div> : ''}

            </fieldset>

            <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1 d-flex justify-content-between'>
              <legend className="float-none m-0 w-auto fs-4 fw-bold">Disponibilidad:</legend>

              <div className='col-2 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="tipodisponible" value="1" ref={txtTodosDispo} onChange={onChekval} id="tipodisponible" type="radio" />
                  <label className="form-check-label" for="exampleRai1">
                    Todos
                  </label>
                </div>
              </div>

              <div className='col-3 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="tipodisponible" value="2" ref={txtEnStock} onChange={onChekval} id="tipodisponible" type="radio" />
                  <label className="form-check-label" for="exampleRai2">
                    En Existencia
                  </label>
                </div>
                {cantis === '0' ? <input type="hidden" ref={txtFechaal} /> : ''}
              </div>

              {cantis === '1' ? '' : <div className='col-3'>
                <div className="form-check">
                  <input className="form-check-input" name="tipodisponible" value="3" ref={txtAgotados} onChange={onChekval} id="tipodisponible" type="radio" />
                  <label className="form-check-label" for="exampleRai3">
                    Agotados
                  </label>
                </div>
              </div>}

              {cantis === '1' ? <div className='col-4'>
                <div className='mr-auto'>
                  <div className="input-group input-group-sm">
                    <label className="input-group-text" id="inputGroup-sizing-sm">A la Fecha:</label>
                    <input type="date" ref={txtFechaal} className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  </div>
                </div>
              </div> :
                ''
              }

            </fieldset>

            <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1'>
              <legend className="float-none m-0 w-auto fs-4 fw-bold">Producto:</legend>

              <div className='col-3 mx-auto mb-3'>
                <div className="form-check">
                  <input className="form-check-input" name="tipoproducto" value="1" ref={txtTodosProductos} onChange={onChekval} id="tipoproducto" type="radio" />
                  <label className="form-check-label" for="exampleRa1">
                    Todos
                  </label>
                </div>
              </div>

              <div className='col-3 mx-auto mb-3'>
                <div className="form-check">
                  <input className="form-check-input" name="tipoproducto" value="2" ref={txtPorProductos} onChange={onChekval} id="tipoproducto" type="radio" />
                  <label className="form-check-label" for="exampleRa2">
                    Por Producto
                  </label>
                </div>
              </div>

              <input type='hidden' ref={txtIdProducto} />

              {inputproducto === 1 ? <div className='col-4 mr-auto mb-3'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">Código:</label>
                  <input type="text" ref={txtInputProducto} disabled={inputproducto === 1 ? false : true} onKeyUp={handleProducto} onBlur={handleProducto} className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  <button disabled={inputproducto === 1 ? false : true} type="button" onClick={catalogoProductoc} className="btn btn-success"><i className="fas fa-search"></i></button>
                </div>
              </div> : ''}

              {inputproducto === 1 ? <div className='col-12 row m-0 mb-1 py-1'>

                <div className='col-12'>
                  <div className="input-group input-group-sm">
                    <label className="input-group-text" id="inputGroup-sizing-sm">Nombre del Producto:</label>
                    <input type="text" ref={txtNombreProducto} disabled={true} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  </div>
                </div>

              </div> : ''}

              <div className='col-12 row m-0 px-0'>

                <div className='col-4 px-1'>
                  <div className="input-group input-group-sm mb-2">
                    <label className="input-group-text" id="inputGroup-sizing-sm">TIPO PRODUCTO:</label>
                    <select ref={txtTipoproducto} name="tproducto" onChange={onChange} className="form-select form-select-sm text-center" disabled={habimarcatipopro} aria-label=".form-select-sm example" >
                      <option value="0">TODOS</option>
                      {tipoproducto && tipoproducto.map((item, index) => (
                        <option key={index} value={item.idtipoproducto}> {item.descripcion} </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className='col-4 px-1'>
                  <div className="input-group input-group-sm mb-2">
                    <label className="input-group-text" id="inputGroup-sizing-sm">MARCA:</label>
                    <select ref={txtMarca} name="marca" onChange={onChange} className="form-select form-select-sm text-center" disabled={habimarcatipopro} aria-label=".form-select-sm example" >
                      <option value="0">TODOS</option>
                      {marca && marca.map((item, index) => (
                        <option key={index} value={item.idmarca}> {item.descripcion} </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className='col-4 px-1'>
                  <div className="input-group input-group-sm mb-2">
                    <label className="input-group-text" id="inputGroup-sizing-sm">FABRICANTE:</label>
                    <select ref={txtFabricante} name="fabricante" onChange={onChange} className="form-select form-select-sm text-center" disabled={habimarcatipopro} aria-label=".form-select-sm example" >
                      <option value="0">TODOS</option>
                      {fabricante && fabricante.map((item, index) => (
                        <option key={index} value={item.idfabricante}> {item.descripcion} </option>
                      ))}
                    </select>
                  </div>
                </div>

              </div>

            </fieldset>

          </div>

        </div>
      </Modal.Body >
      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto">

          <div className='col-md-12 ml-auto px-0 m-0 d-flex justify-content-end'>
            <button
              onClick={imprimir2}
              className="btn btn-sm rounded-pill btn-primary mx-1"
            >
              <i className="fas fa-print"> Catalogo</i>
            </button>
            <button ref={btnAcepta} disabled={habilitado} onClick={onChangeValidar} className="btn btn-sm rounded-pill btn-primary mx-1"><i className="fas fa-print">  Imprimir</i></button>
            <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill mx-1"><i className="fas fa-window-close"> Cancelar</i></button>
          </div>
        </div>

      </Modal.Footer>
      <CatalogoAlmacen
        show={mostrar}
        onHideCancelar={() => setMostrar(false)}
        onHideAceptaCatalogo={handleAceptaAlmacen}
      />
      <CatalogoProductosExistencias
        show={mostrar1}
        onHideCancelar={() => setMostrar1(false)}
        onHideAceptaCatalogo={handleAceptaProducto}
      />
    </Modal >
  );
}




// WEBPACK FOOTER //
// ./src/components/almacen/modalImprimirProductos.js